import { Container } from 'react-bootstrap'

export default function Interests() {
  return (
    <Container id='interests'>
        <hr />
        <h1>My Interests</h1>

        <p>I have a passion for gaming, enjoying games from most genres. I get a lot of enjoyment out of a well told single player experience. I particularly like online gaming, such as World of Warcraft and many ARPGs, having built a community of players that play together weekly.
        I am a fan of Leeds United and follow football, mostly the Championship, but hopefully the Premier League next season. 
        I also have a passion for history, particularly of the classical variety. Inspired from playing games based on ancient civilisations to studying it at university, I have always been interested in learning about the people and places of the ancient world, especially Greeks and Romans.</p>
    </Container>
  )
}
